import { render, staticRenderFns } from "./KhachDuLichList.vue?vue&type=template&id=e61368f2"
import script from "./KhachDuLichList.vue?vue&type=script&lang=js"
export * from "./KhachDuLichList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports